import * as types from "../../mutation-types";

export default {
    [types.FETCH_STRIPE_SUCCESS] (state, { data }) {
        state.stripe = data
    },

    [types.FETCH_STRIPE_FAILURE] (state) {
        state.stripe = null
    },

    [types.FETCH_PAYMENT_METHODS_SUCCESS] (state, { data }) {
        state.paymentMethods = data
    },

    [types.FETCH_PAYMENT_METHODS_FAILURE] (state) {
        state.paymentMethods = null
    },

    [types.FETCH_INTENT_TOKEN_SUCCESS] (state, { data }) {
        state.intentToken = data
    },

    [types.FETCH_INTENT_TOKEN_FAILURE] (state) {
        state.intentToken = null
    },

    [types.FETCH_PLAN_ID_SUCCESS] (state, { data }) {
        state.planId = data
    },

    [types.FETCH_PLAN_ID_FAILURE] (state) {
        state.planId = null
    },
}


// WEBPACK FOOTER //
// ./src/store/modules/api/mutations.js